import { ref } from 'vue'

export const roleRefreshCallback = ref<Function>()
